'use client';

/* eslint-disable no-console */
import {COOKIE_OID, setCookie} from '@utils/cookies';
import {getEnvConfig} from '@web-catalog/env';
import {useSetAtom} from 'jotai';
import {useSearchParams} from 'next/navigation';
import {useEffect} from 'react';

import {OmicronDTO} from '@web-catalog/api';
import {OmicronConfigSchema} from '@web-catalog/api/omicronApi/types';

import {applyOmicronConfigOverridesFromQuery} from '@utils/omicron/applyOmicronConfigOverridesFromQuery';
import {setOidSegments} from '@utils/omicron/setOidSegments';
import {omicronConfigClientAtom} from '@web-catalog/store/omicron';

type Props = {
  omicron: OmicronDTO;
};

export const OmicronClientInitializer = ({omicron}: Props) => {
  const setOmicronClientConfig = useSetAtom(omicronConfigClientAtom);
  const searchParams = useSearchParams();

  useEffect(() => {
    const data = {
      ...omicron,
      config: {...omicron.config},
    };
    if (searchParams?.has('_ab_debug')) {
      console.info(
        'Got ab config from server-side: ' +
          JSON.stringify(omicron, undefined, 2),
      );
    }
    if (data.writeOidCookie && data.oid) {
      setCookie(COOKIE_OID, data.oid, {
        domain: getEnvConfig().COOKIE_DOMAIN,
        secure: true,
        httpOnly: false,
        sameSite: 'none',
        expires: 3650, // 10 лет (как ставит сам омикрон)
      });
    }

    setOidSegments(data);

    applyOmicronConfigOverridesFromQuery({
      searchParams,
      schema: OmicronConfigSchema,
      omicronResponse: data,
    });

    setOmicronClientConfig(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
